import { motion } from 'framer-motion';
import { useState } from 'react';

export default function Testimonials() {
  const [currentIndex, setCurrentIndex] = useState(0);

  const testimonials = [
    {
      name: 'Sarah Johnson',
      location: 'New York, USA',
      avatar: 'https://public.readdy.ai/ai/img_res/73ab6c8a4281364b62925edbb65deac7.jpg',
      rating: 5,
      title: 'Best Vacation Ever!',
      text: 'Candy World Tours made our European adventure absolutely unforgettable. Every detail was perfectly planned, and our guide was knowledgeable and friendly. We felt safe and well taken care of throughout the entire trip.',
    },
    {
      name: 'Michael Chen',
      location: 'Singapore',
      avatar: 'https://readdy.ai/api/search-image?query=professional%20portrait%20of%20smiling%20asian%20man%20with%20confident%20friendly%20expression%20against%20simple%20clean%20background&width=96&height=96&seq=test2&orientation=squarish',
      rating: 5,
      title: 'Exceptional Service',
      text: 'From booking to the end of our journey, the service was exceptional. The team went above and beyond to accommodate our requests and ensure we had the best experience possible. Highly recommend!',
    },
    {
      name: 'Emily Rodriguez',
      location: 'Madrid, Spain',
      avatar: 'https://readdy.ai/api/search-image?query=professional%20portrait%20of%20smiling%20hispanic%20woman%20with%20warm%20cheerful%20expression%20against%20simple%20clean%20background&width=96&height=96&seq=test3&orientation=squarish',
      rating: 5,
      title: 'Amazing Experience',
      text: 'Our family trip to Asia was incredible thanks to Candy World Tours. They handled everything seamlessly, and the itinerary was perfect for traveling with kids. We created memories that will last a lifetime.',
    },
    {
      name: 'David Thompson',
      location: 'London, UK',
      avatar: 'https://readdy.ai/api/search-image?query=professional%20portrait%20of%20smiling%20british%20man%20with%20friendly%20approachable%20expression%20against%20simple%20clean%20background&width=96&height=96&seq=test4&orientation=squarish',
      rating: 5,
      title: 'Highly Professional',
      text: 'The professionalism and attention to detail were outstanding. Our African safari exceeded all expectations. The accommodations were luxurious, and seeing wildlife in their natural habitat was breathtaking.',
    },
    {
      name: 'Lisa Anderson',
      location: 'Toronto, Canada',
      avatar: 'https://readdy.ai/api/search-image?query=professional%20portrait%20of%20smiling%20canadian%20woman%20with%20warm%20genuine%20expression%20against%20simple%20clean%20background&width=96&height=96&seq=test5&orientation=squarish',
      rating: 5,
      title: 'Worth Every Penny',
      text: 'Initially worried about the cost, but it was worth every penny. The value we received was incredible - from the hotels to the experiences. Candy World Tours delivers on their promises.',
    },
  ];

  const nextSlide = () => {
    setCurrentIndex((prev) => (prev + 1) % testimonials.length);
  };

  const prevSlide = () => {
    setCurrentIndex((prev) => (prev - 1 + testimonials.length) % testimonials.length);
  };

  return (
    <section className="py-24 bg-[#FAF8F5]">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <div className="flex items-center justify-center gap-2 mb-4">
            <div className="w-2 h-2 rounded-full bg-accent-orange"></div>
            <span className="text-xs uppercase tracking-wider text-accent-orange font-semibold">
              Testimonials
            </span>
          </div>
          <h2 className="text-5xl font-bold text-navy-900 mb-6">
            Loved by Travelers<br />Worldwide
          </h2>
          <div className="flex items-center justify-center gap-2 text-4xl">
            <span className="font-bold text-navy-900">4.9</span>
            <div className="flex gap-1">
              {[...Array(5)].map((_, i) => (
                <i key={i} className="ri-star-fill text-accent-orange"></i>
              ))}
            </div>
          </div>
          <p className="text-gray-600 mt-2">Based on 500+ reviews</p>
        </div>

        {/* Testimonials Carousel */}
        <div className="relative">
          <div className="overflow-hidden">
            <motion.div
              className="flex gap-8"
              animate={{ x: `-${currentIndex * 33.33}%` }}
              transition={{ duration: 0.5, ease: 'easeInOut' }}
            >
              {testimonials.map((testimonial, index) => (
                <div
                  key={index}
                  className="min-w-[calc(33.33%-1.33rem)] bg-white rounded-3xl p-8 shadow-lg"
                >
                  {/* Stars */}
                  <div className="flex gap-1 mb-4">
                    {[...Array(testimonial.rating)].map((_, i) => (
                      <i key={i} className="ri-star-fill text-accent-orange text-xl"></i>
                    ))}
                  </div>

                  {/* Title */}
                  <h3 className="text-xl font-bold text-navy-900 mb-3 leading-snug">
                    {testimonial.title}
                  </h3>

                  {/* Review Text */}
                  <p className="text-gray-600 leading-relaxed mb-6 line-clamp-4">
                    {testimonial.text}
                  </p>

                  {/* Author */}
                  <div className="flex items-center gap-4 pt-6 border-t border-gray-100">
                    <div className="w-12 h-12 rounded-full overflow-hidden flex-shrink-0">
                      <img
                        src={testimonial.avatar}
                        alt={testimonial.name}
                        className="w-full h-full object-cover"
                      />
                    </div>
                    <div>
                      <p className="font-bold text-navy-900">{testimonial.name}</p>
                      <p className="text-sm text-gray-500">{testimonial.location}</p>
                    </div>
                  </div>
                </div>
              ))}
            </motion.div>
          </div>

          {/* Navigation Buttons */}
          <button
            onClick={prevSlide}
            className="absolute left-0 top-1/2 -translate-y-1/2 -translate-x-4 w-12 h-12 bg-white rounded-full shadow-lg flex items-center justify-center hover:bg-navy-900 hover:text-white transition-all cursor-pointer"
          >
            <i className="ri-arrow-left-s-line text-2xl"></i>
          </button>
          <button
            onClick={nextSlide}
            className="absolute right-0 top-1/2 -translate-y-1/2 translate-x-4 w-12 h-12 bg-white rounded-full shadow-lg flex items-center justify-center hover:bg-navy-900 hover:text-white transition-all cursor-pointer"
          >
            <i className="ri-arrow-right-s-line text-2xl"></i>
          </button>

          {/* Dots Indicator */}
          <div className="flex justify-center gap-2 mt-8">
            {testimonials.map((_, index) => (
              <button
                key={index}
                onClick={() => setCurrentIndex(index)}
                className={`w-2 h-2 rounded-full transition-all cursor-pointer ${
                  index === currentIndex ? 'bg-accent-pink w-8' : 'bg-gray-300'
                }`}
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}